<template>
  <div class="container">
    <QueryFrame
      @handlePage="handlePage"
      @handlePageSize="handlePageSize"
      :current="page"
      :count="count">
      <div slot="queryParams" class="queryContainer">
        <div class="queryItem" v-if="roleType!==2">
          <label>门店名称:</label>
          <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
        </div>
        <div class="queryItem">
            <goodsSearchItem v-model="query.nameMix"></goodsSearchItem>
        </div>
        <div class="queryItem">
          <label>盘点计划:</label>
          <lk-select class="item" filterable clearable v-model.trim="query.stocktakingPlanId" placeholder="全部">
            <lk-option v-for="item in stocktakingPlanList" :key="item.id" :value="item.id">{{item.name}}</lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>盘点时间:</label>
          <timeStampDatePicker 
            type='daterange' 
            placeholder='请选择' 
            class="item" 
            v-model="query.operatorTimeRange"
            :options="disabledDateFuture"
          ></timeStampDatePicker>
        </div>
        <div class="queryItem">
          <label>申请时间:</label>
          <timeStampDatePicker 
            type='daterange' 
            placeholder='请选择' 
            class="item" 
            v-model="query.createTimeRange"
            :options="disabledDateFuture"
          ></timeStampDatePicker>
        </div>
        <div class="queryItem">
          <label>审批时间:</label>
          <timeStampDatePicker 
            type='daterange' 
            placeholder='请选择' 
            class="item" 
            v-model="query.apprpvalTimeRange"
            :options="disabledDateFuture"
          ></timeStampDatePicker>
        </div>
        <div class="queryItem">
          <label>损溢单号:</label>
          <lk-input class="item" clearable v-model.trim="query.stocktakingProfitAndLossCode"></lk-input>
        </div>
        <div class="queryItem">
          <label>是否调整库存:</label>
          <lk-select class="item" clearable v-model.trim="query.changeInventory" placeholder="全部">
            <lk-option v-for="item in ifAdjustInventoryOptions" :key="item.id" :value="item.id">
              {{item.name}}
            </lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>盘点单搜索:</label>
          <lk-input class="item" clearable v-model.trim="query.stocktakingPlanCode"></lk-input>
        </div>
        <div class="queryItem">
          <label>审批状态:</label>
          <lk-select class="item" clearable v-model.trim="query.statusList" placeholder="全部" :multiple="true">
            <lk-option v-for="item in checkStatusList" :key="item.id" :value="item.id">
              {{item.name}}
            </lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <lk-button type="primary" class="mr" @click="handleSearch">查询</lk-button>
          <lk-button @click="handleReset">重置</lk-button>
        </div>
      </div>
      <div slot="table">
        <div style="margin-bottom: 12px;">
          <lk-button class="mr8" type="primary" @click="addStocktakingProfitAndLoss" v-if="handlePermission('stocktakingProfitAndLossCreate')">新建盘点损溢单</lk-button>
          <DownloadButton  @on-click="download" v-if="handlePermission('stocktakingProfitAndLossExport')"></DownloadButton>
        </div>
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import inventory from '../../services/inventory';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import DownloadButton from '../../components/download/DownloadButton';

export default {
  name: 'StocktakingProfitAndLoss',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    DownloadButton,
  },
  data() {
    return {
      stocktakingPlanList: [],
      boolsMap: new Map().set(1, '是').set(2, '否'),
      statusMap: new Map().set(1, '启用').set(2, '禁用'),
      approveStatusMap: new Map([
        [1, '审批中'],
        [2, '审批通过'],
        [3, '审批驳回'],
      ]),
      ifAdjustInventoryOptions: [
        {
          id: 1,
          name: '是'
        },
        {
          id: 2,
          name: '否'
        },
      ],
      checkStatusList: [
        {
          id: 1,
          name: '审批中',
        },
        {
          id: 2,
          name: '审批通过',
        },
        {
          id: 3,
          name: '审批驳回',
        },
      ],
      query: {
        storeIdList: [],
        goodsName: null,
        drugSerialCode: null,
        stocktakingPlanId: null,
        stocktakingProfitAndLossCode: null,
        stocktakingPlanCode: null,
        statusList: [],
        changeInventory: null,
        operatorTimeRange: null,
        createTimeRange: null,
        apprpvalTimeRange: null,
      },
      columns: [
        {
          title: '序号',
          type: 'index',
          width: 80,
          indexMethod: row => (row._index + this.size * (this.page - 1)) + 1,
          tooltip: true,
        },
        {
          title: '门店名称',
          key: 'storeName',
          minWidth: 160,
          tooltip: true,
        },
        {
          title: '损溢单号',
          key: 'stocktakingProfitAndLossCode',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '状态',
          key: 'statusStr',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '盘点计划',
          key: 'stocktakingPlanName',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '盘点时间',
          key: 'operatorTime',
          minWidth: 130,
          tooltip: true,
        },
        {
          title: '商品编码',
          key: 'drugSerialCode',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '商品名称',
          key: 'goodsName',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '通用名称',
          key: 'approvedDrugNames',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '规格',
          key: 'specifications',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '剂型',
          key: 'dosageForm',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '商品状态',
          key: 'goodsStoreStatusStr',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '单位',
          key: 'drugMiniPackageUnit',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '仓库',
          key: 'warehouseName',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '货位',
          key: 'locationCode',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '批号',
          key: 'goodsBatchNumber',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '批次',
          key: 'goodsBatchSeq',
          minWidth: 110,
          tooltip: true,
        },
        { title: '系统冻结数量',
          key: 'breakageFrozenAmount',
          minWidth: 110,
          tooltip: true,
        },
        { title: '手动冻结数量',
          key: 'manualFrozenNum',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '可销售数量',
          key: 'inventoryCount',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '在库数量',
          key: 'inInventoryCount',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '实盘数量',
          key: 'realCount',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '是否存在差异',
          key: 'hasDiffStr',
          minWidth: 130,
          tooltip: true,
        },
        {
          title: '是否调整库存',
          key: 'changeInventoryStr',
          minWidth: 130,
          tooltip: true,
        },
        {
          title: '创建人',
          key: 'createUserName',
          minWidth: 110,
          tooltip: true,
        },
        {
          title: '申请时间',
          key: 'createTime',
          minWidth: 150,
          tooltip: true,
        },
        {
          title: '审批时间',
          key: 'approvalTime',
          minWidth: 150,
          tooltip: true,
        },
        {
          title: '损溢数量',
          key: 'adjustCount',
          minWidth: 110,
          tooltip: true,
          fixed: 'right',
        },
        {
          title: '损溢金额',
          key: 'adjustTotalPrice',
          minWidth: 110,
          tooltip: true,
          fixed: 'right',
        },
        {
          title: '损溢原因',
          key: 'adjustReason',
          minWidth: 110,
          tooltip: true,
          fixed: 'right',
        },
      ],
      tableData: [],
      disabledDate: {
        disabledDate (date) {
          if ( date > Date.now()) {
            return date && date.valueOf() > Date.now() + 7776000000
          } else {
            return date && date.valueOf() < Date.now() - 86400000
          }
        }
      },
      disabledDateFuture: {
        disabledDate (date) {
          return date && date.valueOf() > Date.now()
        }
      }
    };
  },
  methods: {
    download() {
      const params = Object.assign({}, this.query);
      params.page = 0;
      params.size = 0;
      if (params.operatorTimeRange instanceof Array && params.operatorTimeRange.length) {
        params.OperatorTimeStart = params.operatorTimeRange[0];
        params.OperatorTimeEnd = params.operatorTimeRange[1];
      }
      if (params.createTimeRange instanceof Array && params.createTimeRange.length) {
        params.createTime = params.createTimeRange[0];
        params.createTimeEnd = params.createTimeRange[1];
      }
      if (params.apprpvalTimeRange instanceof Array && params.apprpvalTimeRange.length) {
        params.approvalTimeStart = params.apprpvalTimeRange[0];
        params.approvalTimeEnd = params.apprpvalTimeRange[1];
      }
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      inventory.downloadStocktakingProfitAndLoss(params).then((res) => {
        if (res.data.status !== 200) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getStocktakingPlanList() {
      return inventory.stocktakingPlanList()
        .then((res) => {
          if (res.data.status === 200) {
            this.stocktakingPlanList = res.data.data;
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      if (this.params.operatorTimeRange instanceof Array && this.params.operatorTimeRange.length) {
        this.params.OperatorTimeStart = this.params.operatorTimeRange[0];
        this.params.OperatorTimeEnd = this.params.operatorTimeRange[1];
      }
      if (this.params.createTimeRange instanceof Array && this.params.createTimeRange.length) {
        this.params.createTime = this.params.createTimeRange[0];
        this.params.createTimeEnd = this.params.createTimeRange[1];
      }
      if (this.params.apprpvalTimeRange instanceof Array && this.params.apprpvalTimeRange.length) {
        this.params.approvalTimeStart = this.params.apprpvalTimeRange[0];
        this.params.approvalTimeEnd = this.params.apprpvalTimeRange[1];
      }
      inventory.stocktakingProfitAndLossList(this.params)
        .then((res) => {
          if (res.data.status === 200) {
            const { count, list } = res.data.data;
            list.forEach((item) => {
              item.goodsStoreStatusStr = this.statusMap.get(item.goodsStoreStatus);
              item.hasDiffStr = this.boolsMap.get(item.hasDiff);
              item.changeInventoryStr = this.boolsMap.get(item.changeInventory);
              item.statusStr = this.approveStatusMap.get(item.status);
              item.createTime = utils.formatDateToSecond(item.createTime);
              item.operatorTime = utils.formatTime(item.operatorTime);
              item.approvalTime = utils.formatDateToSecond(item.approvalTime);
              // 损溢金额 = 损溢数量 * 税前价格 【备注: 损溢数量和金额后期由服务器端输出】
              item.adjustTotalPrice = utils.addPlusPrefix(utils.toFixed2(item.priceBeforeTax * item.adjustCount));
              item.adjustCount = utils.addPlusPrefix(item.adjustCount.toFixed(2));
            });
            this.count = count;
            this.tableData = list;
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    addStocktakingProfitAndLoss() {
      this.$router.push({ name: 'stocktakingProfitAndLossCreate' });
    },
    handleReset() {
      this.query = {};
    },
  },
  created() {
    this.getStocktakingPlanList();
    this.handleSearch(true);

    if (this.roleType !== 2) {
      this.columns.splice(1, 0, { title: '门店名称', key: 'storeName', minWidth: 116 });
    }
  },
};
</script>
<style lang="less" scoped>
</style>
